import React, { FC, memo } from "react";
import { IM02CategoryCarousel } from "@montana/models/generated/cms.interface";
import { Media } from "@montana/shared/media";
import { Link } from "@montana/shared/link";
import { isBrowser } from "@montana/helpers/browser.helper";
import { RichText } from "@montana/shared/rich-text";
import { epiMediaRatioToEnum } from "@montana/helpers/epi-mapping.helper";
import { Button, ButtonStyles } from "@montana/shared/button";
import Carousel from "@montana/shared/carousel";

export const M02CategoryCarouselBlock: FC<IM02CategoryCarousel> = memo((props: IM02CategoryCarousel) => {
    const {
        header,
        categoryCarouselLayout,
        categories,
        galleryMode,
    } = props

    if (!isBrowser) return <></>;

    const CategoryCarouselHeader = () => header ? <RichText text={header} disableAppear /> : <></>;

    const ratioOfFirstItem = categories?.length && categories[0].imageDisplayRatio?.toLowerCase() || 'portrait';

    return (
        <section className={`category-carousel${categoryCarouselLayout === "3" ? ' category-carousel--large' : ''} category-carousel--first-item-${ratioOfFirstItem}`}>
            {!!categories?.length && (
                <Carousel
                    header={<CategoryCarouselHeader />}
                    insideBrokenContainer
                >
                    {categories.map((category, index) =>
                        <div
                            className={`category-carousel__card category-carousel__card--${category.imageDisplayRatio?.toLowerCase()}`}
                            key={`category-carousel__card__${category.name}__${index}`}
                        >
                            <Link
                                to={!category.url ? undefined : category.url}
                                title={category.name}
                            >
                                <Media
                                    image={category.image}
                                    mediaRatio={epiMediaRatioToEnum(category.imageDisplayRatio)}
                                    sizes={categoryCarouselLayout === "3" ? [
                                        '(min-width: 768px) 1010px',
                                        '710px'
                                    ].join(', ') : [
                                        '(min-width: 768px) 600px',
                                        '500px'
                                    ].join(', ')}
                                    placeholder
                                />
                            </Link>
                            {!galleryMode && (
                                <Link
                                    className="category-carousel__card-title"
                                    to={!category.url && !galleryMode ? undefined : category.url}
                                    title={category.name}
                                >
                                    <p>{category.name}</p>
                                </Link>
                            )}
                            {(!galleryMode && !!category.url && category.linkAsButton) && (
                                <Button className="category-carousel__cta"
                                    style={ButtonStyles.Secondary}
                                    href={category.url}
                                    title={category.name}
                                    text={category.linkText}
                                />
                            )}
                        </div>
                    )}
                </Carousel>
            )}
        </section>
    );
});
